// extracted by mini-css-extract-plugin
export default {"zebra":"styles_zebra__+CmBF"};